import locales from "@/consts/locales"
import { setCookie } from "@/utils/cookies"
import getCurrentLocale from "@/utils/getCurrentLocale"

import { CHANGE_LANGUAGE } from "./mutationTypes.js"

const state = () => {
  return {
    locales,
    currentLocale: getCurrentLocale()
  }
}

const mutations = {
  [CHANGE_LANGUAGE](state, locale) {
    state.currentLocale = locale

    setCookie("language", locale)
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
